
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/how-to/pinning-service",
      function () {
        return require("private-next-pages/docs/how-to/pinning-service.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/how-to/pinning-service"])
      });
    }
  